import React from "react";
import { useTranslation } from "react-i18next";

export default function Terms() {
  const { t } = useTranslation();
  const sections = t("terms.sections", { returnObjects: true }) || [];
  return (
    <article className="fp-legal">
      <header className="fp-legal__head">
        <span className="fp-eyebrow">{t("policies_teaser.eyebrow")}</span>
        <h1>{t("terms.title")}</h1>
        <p className="fp-legal__meta">{t("terms.updated")}</p>
      </header>
      <p className="fp-legal__intro">{t("terms.intro")}</p>
      <div className="fp-legal__body">
        {Array.isArray(sections) && sections.map((s, i) => (
          <section key={i}>
            <h2>{s.h}</h2>
            <p>{s.p}</p>
          </section>
        ))}
      </div>
    </article>
  );
}
